import cx from 'classnames';
import {isUndefined} from 'lodash';
import {useMemo} from 'react';

import {Icon, TestAttribute, WithTestAttributeProps} from 'components';

type Props = {
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
    selectable?: boolean;
    value?: any;
    selected?: boolean;
    selectedValue?: any;
    onClick?: (value: any) => void;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & WithTestAttributeProps;

export const ListItem: React.FC<Props> = (
    {children, className, disabled, selectable = true, value, selected: selectedProp, selectedValue, testAttribute, ...rest}: Props
) => {
    const selected = useMemo(() => selectedProp || (!isUndefined(value) && value === selectedValue), [selectedProp, value, selectedValue]);
    return (
        <TestAttribute testAttribute={testAttribute}>
            <div
                {...rest}
                className={cx(className, 'tw-px-5 tw-py-2 tw-bg-opacity-5 tw-relative', {
                    'tw-text-default-dimmed tw-cursor-default tw-opacity-30': disabled,
                    'hover:tw-bg-primary-light hover:tw-bg-opacity-25 tw-cursor-pointer': !disabled && selectable,
                    'tw-bg-primary-light tw-bg-opacity-25 tw-pr-12': selected
                })}
                onClick={disabled ? null : () => {
                    rest?.onClick?.(value);
                }}
            >
                {children}
                {selected && <Icon name='check' primary className='tw-absolute tw-right-3 tw-top-1.5' />}
            </div>
        </TestAttribute>
    );
};
